module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/instagram/chapel_sns_04-900590813b91779fd09c2541a7acb93b.jpg";